import { Container, Stack, Typography } from "@mui/material"
import { RepeatableComponent } from "../../../types/GiftSubscriptionLandingPage"
import styles from './GiftRepeatableContent.module.css'

interface GiftRepeatableContentProps {
    repeatableContent: RepeatableComponent[]
}

const GiftRepeatableContent = (props: GiftRepeatableContentProps) => {
    return <>
        {props.repeatableContent.map(entry =>
            <Stack direction={`row`} key={entry.text}>
                <Container className={styles.imgContainer}>
                    <img src={entry.thumbnail} className={styles.img} alt={`thumbnail image ${entry.text}`}/>
                </Container>
                <Typography className={styles.repeatableContentText}>{entry.text}</Typography>
            </Stack>,
        )}
    </>

}

export default GiftRepeatableContent